module.exports = __webpack_public_path__ + "static/media/solution-tube-a-plus-opened.e8eedb79.svg";